var map = {
	"./1.png": "./src/assets/testJedan/1.png",
	"./10.png": "./src/assets/testJedan/10.png",
	"./11.png": "./src/assets/testJedan/11.png",
	"./12.png": "./src/assets/testJedan/12.png",
	"./13.png": "./src/assets/testJedan/13.png",
	"./14.png": "./src/assets/testJedan/14.png",
	"./15.png": "./src/assets/testJedan/15.png",
	"./16.png": "./src/assets/testJedan/16.png",
	"./17.png": "./src/assets/testJedan/17.png",
	"./18.png": "./src/assets/testJedan/18.png",
	"./19.png": "./src/assets/testJedan/19.png",
	"./2.png": "./src/assets/testJedan/2.png",
	"./20.png": "./src/assets/testJedan/20.png",
	"./21.png": "./src/assets/testJedan/21.png",
	"./22.png": "./src/assets/testJedan/22.png",
	"./23.png": "./src/assets/testJedan/23.png",
	"./24.png": "./src/assets/testJedan/24.png",
	"./25.png": "./src/assets/testJedan/25.png",
	"./26.png": "./src/assets/testJedan/26.png",
	"./27.png": "./src/assets/testJedan/27.png",
	"./28.png": "./src/assets/testJedan/28.png",
	"./29.png": "./src/assets/testJedan/29.png",
	"./3.png": "./src/assets/testJedan/3.png",
	"./30.png": "./src/assets/testJedan/30.png",
	"./31.png": "./src/assets/testJedan/31.png",
	"./32.png": "./src/assets/testJedan/32.png",
	"./33.png": "./src/assets/testJedan/33.png",
	"./34.png": "./src/assets/testJedan/34.png",
	"./35.png": "./src/assets/testJedan/35.png",
	"./36.png": "./src/assets/testJedan/36.png",
	"./37.png": "./src/assets/testJedan/37.png",
	"./38.png": "./src/assets/testJedan/38.png",
	"./39.png": "./src/assets/testJedan/39.png",
	"./4.png": "./src/assets/testJedan/4.png",
	"./5.png": "./src/assets/testJedan/5.png",
	"./6.png": "./src/assets/testJedan/6.png",
	"./7.png": "./src/assets/testJedan/7.png",
	"./8.png": "./src/assets/testJedan/8.png",
	"./9.png": "./src/assets/testJedan/9.png",
	"./Primer1RT1.png": "./src/assets/testJedan/Primer1RT1.png",
	"./primer1.png": "./src/assets/testJedan/primer1.png",
	"./vezba2test1.png": "./src/assets/testJedan/vezba2test1.png",
	"./vezba3test1.png": "./src/assets/testJedan/vezba3test1.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/testJedan sync \\.png$";